import React, { useRef } from 'react';
import styles from './tab-container.module.css';
import { TabContainer as TabContainerProp } from '../../typescript/component';
import ProductOverview from '../specialized/product-overview';
import ProductSpecs from '../specialized/product-specs';
import ResourceGrid from '../grids/resource-grid';

export default function TabContainer({
  tab_container,
  locale,
}: {
  tab_container: TabContainerProp;
  locale: string;
}) {
  const productOverview = useRef(null);
  const productSpecs = useRef(null);
  const productResources = useRef(null);

  const additionalResources = {
    ...tab_container.additional_resources,
    component_type: tab_container.additional_resources.component_type || 'Blog Grid',
    cta: {
      ...tab_container.additional_resources.cta,
      title: tab_container.additional_resources.cta.title || 'View All Resources',
      url:
        tab_container.additional_resources.cta.href ??
        tab_container.additional_resources.cta.url ??
        '/resources',
    },
  };

  return (
    <div className={styles.tabContainer}>
      <section ref={productOverview}>
        <ProductOverview product_overview={tab_container.overview} noGap={true} />
      </section>
      <section ref={productSpecs}>
        <ProductSpecs product_specs={tab_container.specifications} />
      </section>
      <section ref={productResources}>
        <ResourceGrid resource_grid={additionalResources} locale={locale} />
      </section>
    </div>
  );
}
